import { CURRENCY_CODE_BY_NUMBER } from "../../../constants";

const isPrepaidTransaction = (type: string) => {
    return ["CASH_OUT", "TRANSFER_CREDIT", "TRANSFER_DEBIT"].includes(type)
}

const TRANSACTION_TYPE_TO_HUMAN_TEXT = {
    LOAD: 'Recarga',
    PURCHASE: 'Compra',
    WITHDRAWAL: 'Extracción por cajero',
    CASH_OUT: 'Comision',
    REFUND: 'Devolucion',
    REVERSAL: 'Reverso',
    VOID: 'Vacio',
    UNKNOWN: 'Desconocido',
    TRANSFER_CREDIT: "Transferencia Crédito" ,
    TRANSFER_DEBIT: "Transferencia Débito",
    ISSUER_FEE: "Cargos del emisor en Porcentaje",
    ISSUER_FIXED_FEE: "Cargos del emisor - Valor Fijo",
    ISSUER_TAX_FEE:"IVA del Cargo",
    ACQUIRER_FEE: "Cargos del Adquirente",
    TRANSFER: "Transferencia"
  };

export class TransactionHelper{

  
    static getMerchant(type: string, merchant: string){
        return ((isPrepaidTransaction(type)))? "Transferencia" : merchant;
    }
    

    static getTransactionType(type){
        return TRANSACTION_TYPE_TO_HUMAN_TEXT[type]
    }

    static getTransactionAmountFormatted(currency, amount){
        const currencyCode = CURRENCY_CODE_BY_NUMBER.get(currency);


        return new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: currencyCode || 'ARS',
        }).format(amount)
    }
}